<script lang="ts" setup>
import type { VBtn } from 'vuetify/components/VBtn';
import { useI18n } from 'vue-i18n';
import { ref } from 'vue';
import useAuthenticatedQuery from '@/composables/apiServices/useAuthenticatedQuery';
import { defineAsyncComponent } from 'vue';
const FeedbackDialog = defineAsyncComponent(() => import('@/components/FeedbackDialog.vue'));

const props = defineProps<{
  buttonVariant: VBtn['variant'];
}>();

const { t } = useI18n();
const { queriesEnabled } = useAuthenticatedQuery();

const isShown = ref(false);
const feedbackModal = ref(false);

const openFeedbackModal = () => {
  feedbackModal.value = true;
  isShown.value = false;
};
</script>

<template>
  <v-dialog v-model="isShown">
    <template #activator="{ props: activatorProps }">
      <slot name="activator" v-bind="activatorProps">
        <v-btn
          data-test-id="about-open-button"
          :ripple="false"
          :variant="props.buttonVariant"
          v-bind="activatorProps"
          sentry-unmask
          >{{ t('about.link') }}
        </v-btn>
      </slot>
    </template>
    <v-container sentry-unmask>
      <v-card>
        <!-- Close Button -->
        <CloseBtn
          :aria-label="t('common.close')"
          class="v-card__close-btn"
          color="on-surface"
          data-test-id="about-dialog-close-top"
          icon
          @click="isShown = false"
        >
          <v-icon>mdi-close</v-icon>
        </CloseBtn>
        <v-card-title>
          {{ t('about.dialog.title') }}
        </v-card-title>
        <v-card-text>
          <div v-html="t('about.dialog.text')" class="about__content"></div>
        </v-card-text>
        <v-card-actions>
          <v-btn
            data-test-id="about-dialog-feedback"
            @click="openFeedbackModal()"
            variant="outlined"
            rounded="6"
          >
            {{ t('about.dialog.actions.feedback') }}
          </v-btn>
          <FilledBtn data-test-id="about-dialog-close-bottom" @click="isShown = false">
            {{ t('about.dialog.actions.close') }}
          </FilledBtn>
        </v-card-actions>
      </v-card>
    </v-container>
  </v-dialog>
  <FeedbackDialog v-if="queriesEnabled" v-model="feedbackModal"></FeedbackDialog>
</template>

<style lang="scss">
.about__content {
  display: flex;
  flex-direction: column;
  gap: 1rem;
}
</style>
